// extracted by mini-css-extract-plugin
export default {"controlDiv":"control_controlDiv__1RLeZ","addIcon":"control_addIcon__3hxN9"};